import axios from '@/utils/request'
import base from './base'
import qs from 'qs'

export function exchangeProductList(data) {
  return axios.post(`${base.url}/business/tradeProduct/list`, qs.stringify(data))
}

export function exchangeProductOptions() {
  return axios.post(`${base.url}/business/tradeProduct/options`)
}

export function exchangeProductCategoryOptions() {
  return axios.post(`${base.url}/business/tradeProduct/category/options`)
}

export function exchangeProductDetail(id) {
  return axios.post(`${base.url}/business/tradeProduct/detail`, qs.stringify({ id }))
}

export function exchangeProductAddOrUpdate(data) {
  return axios.post(`${base.url}/business/tradeProduct/addOrUpdate`, JSON.stringify(data), {
    headers: { 'Content-Type': 'application/json' }
  })
}

export function exchangeProductDeleteBatchIds(ids) {
  return axios.post(`${base.url}/business/tradeProduct/deleteBatchIds`, qs.stringify({ ids }))
}

export function exchangeProductStatus(id, status) {
  return axios.post(`${base.url}/business/tradeProduct/status`, qs.stringify({ id, status }))
}

export function exchangeProductLogList(data) {
  return axios.post(`${base.url}/business/tradeProduct/log/list`, qs.stringify(data))
}

export function exchangeProductSessionList(productId) {
  return axios.post(`${base.url}/business/tradeProduct/session/list`, qs.stringify({ productId }))
}

export function exchangeProductSyncAll(data = {}) {
  return axios.post(`${base.url}/business/tradeProduct/sync/all`, JSON.stringify(data), {
    headers: { 'Content-Type': 'application/json' }
  })
}

export function exchangeProductSyncOne(productCode) {
  return axios.post(`${base.url}/business/tradeProduct/sync/one`, qs.stringify({ productCode }))
}
